/**
 * AdSlot — AdSense-ready placeholder. Clearly labelled and non-deceptive.
 * No live ad code is injected in Phase 1; wire a Publisher ID later.
 *
 * variant: "header" (leaderboard 728x90), "in-article" (responsive),
 *          "sidebar" (300x250), "footer" (responsive)
 */
const SIZES = {
  header: { label: "Leaderboard · 728×90", minH: "min-h-[90px]" },
  "in-article": { label: "In-Article · Responsive", minH: "min-h-[120px]" },
  sidebar: { label: "Medium Rectangle · 300×250", minH: "min-h-[250px]" },
  footer: { label: "Footer · Responsive", minH: "min-h-[90px]" },
};

export const AdSlot = ({ variant = "in-article", className = "" }) => {
  const cfg = SIZES[variant] || SIZES["in-article"];
  return (
    <div
      data-testid="ad-slot-placeholder"
      data-ad-slot={variant}
      role="complementary"
      aria-label="Advertisement placeholder"
      className={`relative w-full overflow-hidden rounded-lg border-2 border-dashed border-brand-navy/80 bg-brand-bg ${cfg.minH} flex flex-col items-center justify-center gap-1 ${className}`}
    >
      <div className="bg-grid pointer-events-none absolute inset-0 opacity-30" />
      <span className="relative z-10 text-[10px] font-semibold uppercase tracking-[0.3em] text-brand-silver">
        Advertisement
      </span>
      <span className="relative z-10 font-mono-data text-[10px] text-brand-silver/50">
        {cfg.label}
      </span>
    </div>
  );
};

export default AdSlot;
